import { Box, Stack, Typography, styled } from "@mui/material";
import { memo } from "react";
import { useFormContext, useWatch } from "react-hook-form";

import { useInvoiceTemplates } from "@/api/services/main/organization/invoice-setting";
import { CollapsibleCard } from "@/components/elements/CollapsibleCard";
import templatePreview from "@/features/organization/invoice/assets/invoice-template-preview.png";
import { TInvoiceForm } from "@/features/organization/invoice/types/InvoiceForm";
import { button, divider, text } from "@/theme/colors";

/** テンプレート設定 — pick the invoice PDF template. Templates come from the master API. */
export const TemplateSection = memo(() => {
  const { control, setValue } = useFormContext<TInvoiceForm>();
  const selectedId = useWatch({ control, name: "templateId" });
  const { templates } = useInvoiceTemplates();

  return (
    <CollapsibleCard title="テンプレート設定">
      <Stack direction="row" gap={3} flexWrap="wrap">
        {templates.map((template) => {
          const templateId = String(template.id);
          const selected = selectedId === templateId;
          return (
            <Stack key={template.id} gap={1} width={213}>
              <Thumbnail selected={selected} onClick={() => setValue("templateId", templateId, { shouldDirty: true })}>
                <img src={template.thumbnailUrl ?? templatePreview} alt={template.name} width={213} />
              </Thumbnail>
              {selected ? (
                <SelectedName>
                  <Typography variant="body14Bold" color={text.white}>
                    {template.name}
                  </Typography>
                </SelectedName>
              ) : (
                <Box textAlign="center" py={1}>
                  <Typography variant="body14" color={text.secondary}>
                    {template.name}
                  </Typography>
                </Box>
              )}
            </Stack>
          );
        })}
      </Stack>
    </CollapsibleCard>
  );
});

TemplateSection.displayName = "TemplateSection";

const Thumbnail = styled(Box, { shouldForwardProp: (prop) => prop !== "selected" })<{ selected: boolean }>`
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid ${({ selected }) => (selected ? button.primary : divider.middle)};
  box-shadow: ${({ selected }) => (selected ? `0 0 0 1px ${button.primary}` : "none")};
  line-height: 0;
  img {
    display: block;
    width: 100%;
    height: auto;
  }
`;

const SelectedName = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${button.primary};
  border-radius: 8px;
  padding: 8px 0;
`;
